import React, { useState, useEffect, useContext } from 'react';
import ReactDOM from "react-dom";
import $ from 'jquery';
import { Pagination, Select, DatePicker, Divider, Space } from 'antd';
import moment from 'moment';
import bootbox from 'bootbox';
import CommonUtils from '../util/CommonUtils';
import ShareVideoEmailTemplate from './email-templates/share-video-template';
import Toastr from 'toastr';
import { Context } from '../../src/views/app';
import API from '../service/SiteKickAPIService';

const { RangePicker } = DatePicker;
const { Option } = Select;

const VideosHistorical = (props) => {

    let appContex = useContext(Context);
    let user = appContex.user;

    let zones = [...user.zones];
    const timezone = user.site_selected.site_iana_timezone;
    let startDate = props.date ? moment(props.date, 'YYYY-MM-DD').add(-6, 'days').startOf('day') : moment().add(-6, 'days');
    let endDate = props.date ? moment(props.date, 'YYYY-MM-DD').startOf('day') : moment();

    const [videos, setVideos] = useState(true);
    const [pagination, setPagination] = useState({ page: 1, pageSize: 6 });
    const [start_date, setStartDate] = useState(startDate.format('YYYY-MM-DD'));
    const [end_date, setEndDate] = useState(endDate.format('YYYY-MM-DD'));
    const [locationId, setLocationId] = useState([]);
    const paginationDefaults = { page: 1, pageSize: 6 };
    const date_defaults = [startDate, endDate];

    useEffect(() => {
        if (locationId && start_date && end_date) {
            getHistoricalVideos();
        }
    }, []);

    let manageCameraFeed = async (operation, extraAtts = {}) => {
        return new Promise(async function (resolve, reject) {
            let zone = extraAtts.zone;
            delete extraAtts.zone;
            let device_iotname = null;
            if (zone.location_device_type === 'uniview') {
                let deviceObj = await CommonUtils.getDevice(zone.device_id, user);
                device_iotname = deviceObj ? deviceObj.device_iotname : null;
            }

            var data = {
                user_login: user.user_login,
                user_token: user.user_token,
                form_input: { operation: operation, device_id: zone.device_id, device_iotname: device_iotname, device_type: zone.location_device_type, ...extraAtts }
            };

            CommonUtils.ajax(
                {
                    url: API.CAMERA.LIVE_FEED,
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(data)
                }
            ).then(
                (res) => {
                    if (res.status) {
                        if (res.status.code === 200)
                            resolve(res.data);
                        else
                            reject(null);
                    } else {
                        reject(null);
                    }
                },
                (error) => {
                    reject(null);
                }
            );
        }).catch((err) => { });
    }

    let getHistoricalVideos = async () => {
        let zone = user.zones.find((l) => l.location_id === locationId[0]);
        if (!zone)
            return;

        $('.video-container, #submitBtn').addClass('hide');
        $('.loading').removeClass('hide');

        let start_time = '00:00:00';
        let end_time = '23:59:00';
        let startTS = moment.tz(start_date + ' ' + start_time, 'America/Chicago').unix();
        let endTS = moment.tz(end_date + ' ' + end_time, 'America/Chicago').unix();

        let extraAtts = {
            customer_id: zone.customer_id,
            location_ids: locationId,
            site_id: zone.site_id,
            start_ts: startTS,
            end_ts: endTS,
            zone: zone
        };

        let result = await manageCameraFeed('get-historic-clip', extraAtts);
        if (result && result.videos && result.videos.length > 0) {
            setVideos(result.videos);

            console.log('this.videos', videos);
        } else {
            setVideos([]);
        }

        $('.video-container, #submitBtn').removeClass('hide');
        $('.loading').addClass('hide');
    }

    const disabledDate = (current) => {
        // Can not select days after today
        return current && current > moment().endOf('day');
    }

    const handleInput = (val, field) => {
        switch (field) {
            case 'location_id':
                setPagination(paginationDefaults);
                setVideos(null);
                setLocationId(val);
                break;
            case 'start_end_dates':
                if (val) {
                    setPagination(paginationDefaults);
                    setVideos(null);
                    setStartDate(val[0].format('YYYY-MM-DD'));
                    setEndDate(val[1].format('YYYY-MM-DD'));
                } else {
                    setPagination(paginationDefaults);
                    setVideos(null);
                    setStartDate(null);
                    setEndDate(null);
                }
                break;

            case 'pagination':
                getHistoricalVideos(val[0], val[1]);
                break;

            default:
                break;
        }
    }

    const shareVideo = (v) => {
        bootbox.prompt({
            closeButton: false,
            inputType: 'textarea',
            title: 'Share Video',
            message: 'Please enter semicolon(;) separated email ids to share video', callback: (email_ids) => {
                if (email_ids) {
                    let email_validation = CommonUtils.validateCommaSeparatedEmails(email_ids);

                    if (email_validation.found === 0) {
                        Toastr.error("No email ids found to share the video.");
                        return false;
                    }

                    if (email_validation.valid.length === 0 || email_validation.invalid.length > 0) {
                        Toastr.error("Invalid Email Addresses found. <br />Please correct and try again ! <br />" + email_validation.invalid.join('<br />'));
                        return false;
                    }

                    let video_perm_link = v.video_url;
                    let container = document.createElement('div');
                    let location = user.zones.find((l) => l.location_id === v.location_id);

                    ReactDOM.render(
                        <ShareVideoEmailTemplate
                            location_name={location.location_name}
                            timestamp={moment.tz(v.sec_timestamp * 1000, timezone).format('MMM DD, YYYY HH:mm')}
                            video_url={video_perm_link}
                            user_name={user.user_name}>
                        </ShareVideoEmailTemplate>, container);


                    CommonUtils.sendEmail({
                        user_login: user.user_login,
                        user_token: user.user_token,
                        site_id: location.site_id,
                        location_id: location.location_id,
                        video_url: video_perm_link,
                        start_time: v.sec_timestamp,
                        end_time: v.sec_timestamp + (v.video_type === 'Recorded Live Video' ? 500 : v.duration),
                        share_email: email_validation.valid.join(';'),
                        video_type: 'Historical'
                    }).then((result) => {
                        Toastr.success("Video shared successfully !!");
                    }, (error) => {
                        Toastr.success("Failed to share the video. Please try again ...");
                        return false;
                    });
                }

            }
        });
    }

    const getVideoInfo = (v, i) => {
        let video_file_name = v.video_url ? v.video_url.split('?')[0] : '';
        let video_url_parts = video_file_name.split('/');
        let video_parts = video_url_parts && video_url_parts.length > 0 ? video_url_parts[video_url_parts.length - 1].split('.')[0].split('_') : [];
        //console.log('video_parts', [video_file_name, video_parts])
        return [moment.tz((!isNaN(video_parts[2]) ? video_parts[2] : v.sec_timestamp) * 1000, timezone).format('YYYY-MM-DD HH:mm:ss'),
        video_parts.length === 4 && !isNaN(video_parts[2]) && !isNaN(video_parts[3]) ? [<br />, moment.tz(1000 * (parseInt(video_parts[2]) + parseInt(video_parts[3])), timezone).format('YYYY-MM-DD HH:mm:ss')] : ''];
    }

    let videos_found = videos && videos.length > 0;
    const enableSubmit = locationId && start_date && end_date;

    return (
        <React.Fragment>
            <div className="page-container">
                <h6 className="font-weight-bold pb-2">Historical Videos</h6>
                <div className="row mb-2">
                    <div className="col-md-12 text-primary">Choose Zone, Date range to retrieve videos.</div>
                </div>
                <div className="row">
                    <div className="col-md-7">
                        <div className="row">
                            <div className="col-md-4 col-12">
                                <Select
                                    allowClear
                                    mode="multiple"
                                    className="mr-1"
                                    value={locationId}
                                    onChange={(obj) => handleInput(obj, 'location_id')}
                                    showSearch
                                    style={{ width: 200 }}
                                    placeholder="Select Zone"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    filterSort={(optionA, optionB) =>
                                        optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                    }
                                    dropdownRender={(menu) => (
                                        <>
                                            {menu}
                                            <Divider style={{ margin: '8px 0' }} />
                                            <Space style={{ padding: '0px 4px' }}>
                                                <button className="btn btn-sm btn-success" onClick={() => {
                                                    handleInput(zones.map((z) => z.location_id), 'location_id');
                                                }}>
                                                    All Zones
                                                </button>
                                            </Space>
                                        </>
                                    )}
                                >

                                    {zones.map((z, i) => (<Option key={i} value={z.location_id}>{z.location_name}</Option>))}

                                </Select>
                            </div>
                            <div className="col-md-8 col-12">
                                <RangePicker disabledDate={disabledDate} defaultValue={date_defaults} onChange={(obj) => handleInput(obj, 'start_end_dates')} />
                                <button id="submitBtn" disabled={!enableSubmit} className="btn btn-sm btn-primary ml-1" onClick={() => getHistoricalVideos()}>Submit</button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5 text-right mt-md-0 mt-3">
                        {videos_found && <Pagination showLessItems={true} showSizeChanger={false} onChange={(page, pageSize) => handleInput([page, pageSize], 'pagination')} defaultPageSize={pagination.pageSize} defaultCurrent={pagination.page} total={pagination.total_found} />}
                    </div>
                </div>

                <div className="border-rounded p-2 mt-4 loading bg-primary-light hide"><i className="fa fa-lg fa-spin fa-lg fa-circle-notch mr-2"></i>Fetching Videos ...</div>
                <div className="row video-container">
                    {videos_found && videos.map((video, i) => (
                        <div className="col-md-3 mt-3" key={i}>
                            <div className="card bg-shadow">
                                <div className="card-body p-0" id={"videos"}>
                                    <video key={video.video_url} width="100%" height="220px" style={{ objectFit: 'cover' }} controls className={"card-img-top video-player " + (video.video_type === 'Time-Lapse Video' ? 'timelapse-video' : 'live-video')} video_container={"videos"}>
                                        <source src={video.video_url} type="video/mp4" />
                                        <source src={video.video_url} type="video/ogg" />
                                    </video>
                                    <div className="card-img-overlay-custom p-1 bg-app">
                                        <span className="px-2 rounded text-white bg-primary p-1 font-size-11">
                                            {zones.map((z) => z.location_id === video.location_id ? z.location_name : '')}
                                        </span>
                                    </div>
                                </div>
                                <div className="card-footer border-0 bg-light">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <span className="text-app font-size-12 font-weight-300">
                                                {getVideoInfo(video)}
                                            </span>
                                        </div>
                                        <div className="col-md-4 text-right">
                                            <span className="text-app font-size-12 font-weight-300">
                                                <button className="btn btn-sm btn-primary" onClick={() => shareVideo(video)}><i className="fa fa-share"></i></button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {videos && videos.length === 0 && <div className="col-12 mt-5 text-bold">No videos found ...</div>}
                </div>
            </div>
        </React.Fragment>
    );
}

export default VideosHistorical;